import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92173ac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog profile-dialog" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "field code" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "getCode c-thirdary"
}
const _hoisted_8 = { class: "btn red" }

import api from '@/api/userApi';
import devices from '@/store/device';
import i18, { State as I18State } from '@/store/i18';
import user from '@/store/user';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].login)

const state = reactive({
    email: '',
    code: '',
    cold: 0
})


function getSms() {
    if (!state.email) {
        return devices.toast(store, lang.value.email_placeholder)
    }
    state.cold = 60;
    onTimer()
    api.getEmailSms(state.email, 'bind')
}

function onTimer() {
    state.cold--
    if (state.cold > 0) {
        setTimeout(onTimer, 1000);
    }
}

async function onSubmit() {
    if (!state.email) {
        return devices.toast(store, lang.value.email_placeholder)
    }
    if (!state.code) {
        return devices.toast(store, lang.value.smscode_placeholder)
    }
    try {
        await user.updateEmail(store, state.email, state.code)
        devices.toast(store, lang.value.set_success)
        emits('close')
    } catch (e: any) {
        devices.toast(store, e.message)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "close icon i-guanbi c-thirdary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(lang).set_email), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).email) = $event)),
        placeholder: _unref(lang).email_placeholder
      }, null, 8, _hoisted_4), [
        [_vModelText, _unref(state).email]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).code) = $event)),
        placeholder: _unref(lang).smscode_placeholder
      }, null, 8, _hoisted_6), [
        [_vModelText, _unref(state).code]
      ]),
      (_unref(state).cold > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(state).cold) + "S", 1))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "getCode c-thirdary link",
            onClick: getSms
          }, _toDisplayString(_unref(lang).smscode_send), 1))
    ]),
    _createElementVNode("div", {
      class: "submit",
      onClick: onSubmit
    }, [
      _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(lang).do_ok), 1)
    ])
  ]))
}
}

})